import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import ByzMuiDataGrid from 'src/components/core-components/mui/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { InpatientRequestResponseDto } from 'src/api/surgery/surgeryServiceDtos';

interface Props {
  t: (key: string) => string;
  showSurgeries: boolean;
  showProcessDetails: boolean;
  selectedSurgery: InpatientRequestResponseDto | null;
  selectedSurgeryOperations: any[];
  processHistory: any[];
  operationsLoading: boolean;
  processHistoryLoading: boolean;
  operationsColumns: GridColDef[];
  processHistoryColumns: GridColDef[];
}

export function OperatingRoomSidePanels({
  t,
  showSurgeries,
  showProcessDetails,
  selectedSurgery,
  selectedSurgeryOperations,
  processHistory,
  operationsLoading,
  processHistoryLoading,
  operationsColumns,
  processHistoryColumns,
}: Props) {
  return (
    <BoxWrapper>
      <Stack spacing={2}>
        {showSurgeries && (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {t('surgery.tables.selectedPatientOperations')}
              </Typography>
              {selectedSurgery && (
                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                  {selectedSurgery.patientname} {selectedSurgery.PatientSurname}
                </Typography>
              )}
              <ByzMuiDataGrid
                columns={operationsColumns}
                rows={selectedSurgeryOperations}
                loading={operationsLoading}
                pageSize={100}
                hideFooterPagination
                hideFooter
                getRowId={(row) => row.id}
                sx={{
                  height: 300,
                  fontSize: '0.7rem',
                  '& .MuiDataGrid-cell': { fontSize: '0.7rem', py: 0.5 },
                  '& .MuiDataGrid-columnHeader': { fontSize: '0.7rem', py: 0.5 },
                }}
              />
            </CardContent>
          </Card>
        )}

        {showProcessDetails && (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {t('surgery.tables.processHistory')}
              </Typography>
              <ByzMuiDataGrid
                columns={processHistoryColumns}
                rows={processHistory}
                loading={processHistoryLoading}
                pageSize={100}
                hideFooterPagination
                hideFooter
                getRowId={(row) => row.id}
                sx={{
                  height: 600,
                  fontSize: '0.78rem',
                  '& .MuiDataGrid-cell': { fontSize: '0.78rem', py: 0.5 },
                  '& .MuiDataGrid-columnHeader': { fontSize: '0.78rem', py: 0.5 },
                  '& .MuiDataGrid-row': {
                    '&:has(.MuiDataGrid-cell[data-field="action"] .MuiBox-root)': {
                      '& .MuiDataGrid-cell[data-field="action"]': {
                        gridColumn: '1 / -1',
                        borderBottom: '2px solid #e0e0e0',
                      },
                      '& .MuiDataGrid-cell[data-field="time"]': {
                        display: 'none',
                      },
                    },
                  },
                }}
              />
            </CardContent>
          </Card>
        )}
      </Stack>
    </BoxWrapper>
  );
}

function BoxWrapper({ children }: { children: React.ReactNode }) {
  return <div style={{ minWidth: '260px', maxWidth: '300px', flex: '0.9 0 260px' }}>{children}</div>;
}
